import Modbury81 from '../Modbury 8/Type 8 (1).webp'
import Modbury82 from '../Modbury 8/Type 8 (2).webp'
import Modbury83 from '../Modbury 8/Type 8 (3).webp'
import Modbury84 from '../Modbury 8/Type 8 (4).webp'
import Modbury85 from '../Modbury 8/Type 8 (5).webp'
import Modbury86 from '../Modbury 8/Type 8 (6).webp'
import Modbury87 from '../Modbury 8/Type 8 (7).webp'
import Modbury88 from '../Modbury 8/Type 8 (8).webp'
import Modbury89 from '../Modbury 8/Type 8 (9).webp'


const Modbury8images =[
Modbury81,Modbury82,Modbury83,Modbury84,Modbury85,Modbury86,Modbury87,Modbury88,Modbury89
]

export default Modbury8images;